import { Navigate, useLocation } from 'react-router-dom';

import { Urls } from './Urls';

/**
 * 기존 `/v2/*` 주소(QA 북마크) → `/v2`를 뗀 새 주소로 옮긴다.
 * `/v2`·`/v2/main`은 메인이 `/`로 바뀌어 홈으로 보낸다. 쿼리·해시는 그대로 유지.
 */
export const LegacyV2Redirect = () => {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/v2/, '');
  const to = ['', '/', '/main'].includes(rest) ? Urls.main.build() : rest;
  return <Navigate to={{ pathname: to, search, hash }} replace />;
};
